import { createSlice } from '@reduxjs/toolkit'
import {createCallIfNotExists as createCall, associateCall} from "./thunks"
import { logOut } from '../authentication/authenticationSlice';

const initialState= { 
  list: {

    pageIndex: 0,
totalRecords: 50,
totalPages: 1,
hasPreviousPage: false,
hasNextPage: false,
elements: []
  }, 
  loading: "idle",
  error: null }

const callSlice = createSlice({
  name: 'calls',
  initialState,
  reducers: {
    clearCallError:(state)=>{
      state.error= null
    }
  },
  extraReducers: {
    [createCall.pending]: (state) => {
        state.loading = "loading"; 
        state.error = null
      },
    [createCall.fulfilled]: (state, action) => {
    state.loading = "succeeded";
    state.list = action.payload
    },
    [createCall.rejected]: (state, action) => {
        state.loading = "failed"; 
        state.error = action.error.message
      },
    [associateCall.pending]: (state) => {
        state.loading = "loading"; 
        state.error = null
      },
    [associateCall.fulfilled]: (state, action) => {
        state.loading = "succeeded";
      },
    [associateCall.rejected]: (state, action) => {
        state.loading = "failed"; 
        state.error = action.error.message
      },
    [logOut]: (state)=> initialState
  }
})

export const {clearCallError} = callSlice.actions

export default callSlice.reducer
